import React from 'react';
import PropTypes from 'prop-types';
import { TabContainer, TabPanel, Tab } from 'yankees-react-utils';
import { Route, NavLink } from 'react-router-dom';

const RouterTabs = ({ tabs, activeColor, alignRight }) => (
    <>
        <TabContainer align={alignRight ? 'right' : undefined}>
            {tabs.map((t) => (
                <Tab key={t.key} as={NavLink} to={t.path} activeColor={activeColor}>{t.title}</Tab>
            ))}
        </TabContainer>
        <TabPanel activeColor={activeColor}>
            {tabs.map((t) => <Route key={t.key} path={t.path} render={t.component} />)}
        </TabPanel>
    </>
);

RouterTabs.propTypes = {
    tabs: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        component: PropTypes.func.isRequired,
    })).isRequired,
    alignRight: PropTypes.bool,
    activeColor: PropTypes.string,
};
RouterTabs.defaultProps = {
    alignRight: true,
    activeColor: undefined,
};

export default RouterTabs;
